// import ReduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './root-reducer';
import Global from '../global';

export default function configureStore(preloadedState) {
  // Be sure to ONLY add this middleware in development!
  const middleware = Global.config.environment !== 'production' ?
    [/*ReduxImmutableStateInvariant(), */thunk] : [thunk];

  return createStore(
    rootReducer,
    preloadedState,
    composeWithDevTools(applyMiddleware(...middleware))
  );
}
